import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const routeTitles: Record<string, string> = {
  '/dashboard': 'Dashboard',
  '/shipping/shipments': 'Shipments',
  '/shipping/journeys': 'Journeys',
  '/shipping/journeys/planner': 'Journey Planner',
  '/shipping/transportJobs': 'Transport Jobs',
  '/shipping/transport/routes/unassigned': 'Unassigned Routes',
  '/assetHire': 'Asset Hire',
  '/assetHire/create': 'Create Asset Hire',
  '/datasets/locations': 'Locations',
  '/datasets/assets': 'Assets',
  '/datasets/assets/create': 'Create Asset',
  '/datasets/workforce': 'Workforce',
  '/datasets/workforceType': 'Workforce Types',
  '/datasets/products': 'Products',
  '/datasets/customers': 'Customers',
  '/datasets/services': 'Services',
  '/datasets/carriers': 'Carriers',
  '/datasets/documentType': 'Document Types',
  '/datasets/loadTemplates': 'Load Templates',
  '/datasets/brands': 'Brands',
  '/settings': 'Settings',
  '/settings/branding': 'Branding',
  '/settings/assetSettings': 'Asset Settings',
  '/settings/assetManagement': 'Asset Management',
  '/settings/userManagement': 'User Management',
  '/settings/integrations': 'Integrations',
  '/settings/shipping': 'Shipping',
  '/settings/rolesPermissions': 'Roles & Permissions',
  '/settings/currencies': 'Currencies',
  '/settings/contacts': 'Contacts',
  '/settings/productGroups': 'Product Groups',
  '/reports': 'Reports',
  '/comingSoon': 'Coming Soon',
}

function getPageName(pathname: string): string {
  if (routeTitles[pathname]) {
    return routeTitles[pathname]
  }

  // Handle dynamic routes like /shipping/shipments/:id
  const pathnames = pathname.split('/').filter((x) => x)
  if (pathnames.length === 0) return 'Dashboard'

  const lastSegment = pathnames[pathnames.length - 1]

  // If the last segment looks like an ID or "edit", use the parent segment
  if (lastSegment === 'edit' || lastSegment === 'create' || /^\d+$/.test(lastSegment)) {
    const parentPath = '/' + pathnames.slice(0, -1).join('/')
    if (routeTitles[parentPath]) {
      return routeTitles[parentPath]
    }
    // For nested dynamic routes like /:id/edit, try stripping further
    if (pathnames.length >= 3) {
      const grandParentPath = '/' + pathnames.slice(0, -2).join('/')
      if (routeTitles[grandParentPath]) {
        return routeTitles[grandParentPath]
      }
    }
    const parentSegment = pathnames[pathnames.length - 2] || lastSegment
    return parentSegment.charAt(0).toUpperCase() + parentSegment.slice(1)
  }

  return lastSegment.charAt(0).toUpperCase() + lastSegment.slice(1)
}

export function usePageTitle(): void {
  const location = useLocation()

  useEffect(() => {
    const pageName = getPageName(location.pathname)
    document.title = `LogikSpark - ${pageName}`
  }, [location.pathname])
}
